import { BaseService } from 'hungry-core2'

import actions from '@actions'

export class ReceiptService extends BaseService {
  setReceipt(json) {
    this.dispatch(actions.setReceipt(json))
  }
}
